import { URLS } from 'config';

export const BACK_URLS: Record<string, string> = {
  [URLS.enquiryWelcome]: URLS.enquiry,
  [URLS.enquiryContactDetails]: URLS.enquiryWelcome,
  [URLS.enquiryWorkDetails]: URLS.enquiryContactDetails,
  [URLS.enquiryProjectBudget]: URLS.enquiryWorkDetails,
  [URLS.enquiryQuoteWelcome]: URLS.enquiry,
  [URLS.enquiryQuoteContactDetails]: URLS.enquiryQuoteWelcome,
  [URLS.enquiryQuoteUploadQuote]: URLS.enquiryQuoteContactDetails,
  [URLS.enquiryQuoteConfirmDetails]: URLS.enquiryQuoteUploadQuote,
};
